import React from 'react';
import { BiLateralStyleListTypes, renderFormattedDateTime, TextComponentLayout } from '../../utils/utils';
import BilateralBlock from '../Bilateral/BilateralBlock/bilateralBlock';
import BilateralImage from '../Bilateral/BilateralImage/bilateralImage';
import TextComponent from '../TextComponent/textComponent';

export default function FeaturedContent({ featuredData }) {
  return (
    <div className="featured-blog">
      <BilateralBlock layoutStyle={BiLateralStyleListTypes.BILATERALSTYLE4}>
        <div>
          <TextComponent
            linksBtn={featuredData?.linkBtn}
            heading={featuredData.title}
            description={featuredData.excerpt}
            layoutStyle={TextComponentLayout.LEFT}
            dateTime={renderFormattedDateTime(featuredData.date)}
          />
        </div>
        <BilateralImage src={featuredData.featureImage} />
      </BilateralBlock>
    </div>
  );
}
